import React from 'react';

export function RatingStartHalf() {
	return (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_739_1763)">
				<path
					d="M17.8449 1.66186C17.7566 1.48379 17.6204 1.33392 17.4515 1.22914C17.2827 1.12437 17.0879 1.06885 16.8892 1.06885C16.6904 1.06885 16.4957 1.12437 16.3268 1.22914C16.1579 1.33392 16.0217 1.48379 15.9334 1.66186L11.5665 10.5088L1.80223 11.9275C1.60522 11.9561 1.42014 12.0392 1.26794 12.1676C1.11574 12.2959 1.00249 12.4643 0.941007 12.6536C0.879519 12.8429 0.872248 13.0457 0.920015 13.239C0.967782 13.4322 1.06868 13.6083 1.2113 13.7472L8.2769 20.6336L6.60863 30.3595C6.57516 30.5555 6.59716 30.7569 6.67213 30.9411C6.7471 31.1253 6.87206 31.2849 7.03291 31.4018C7.19376 31.5187 7.38409 31.5883 7.58242 31.6028C7.78075 31.6173 7.97917 31.576 8.1553 31.4837L16.8892 26.8907L25.623 31.4837C25.7992 31.576 25.9976 31.6173 26.1959 31.6028C26.3942 31.5883 26.5846 31.5187 26.7454 31.4018C26.9063 31.2849 27.0312 31.1253 27.1062 30.9411C27.1812 30.7569 27.2032 30.5555 27.1697 30.3595L25.5014 20.6315L32.567 13.7472C32.7096 13.6083 32.8105 13.4322 32.8583 13.239C32.9061 13.0457 32.8988 12.8429 32.8373 12.6536C32.7758 12.4643 32.6626 12.2959 32.5104 12.1676C32.3582 12.0392 32.1731 11.9561 31.9761 11.9275L22.2118 10.5088L17.8449 1.66186Z"
					fill="#C8D2DB"
				/>
			</g>
			<g clipPath="url(#clip1_739_1763)">
				<path
					d="M16.3268 1.22914C16.4957 1.12437 16.6904 1.06885 16.8892 1.06885V26.8907L8.1553 31.4837C7.97917 31.576 7.78075 31.6173 7.58242 31.6028C7.38409 31.5883 7.19376 31.5187 7.03291 31.4018C6.87206 31.2849 6.7471 31.1253 6.67213 30.9411C6.59716 30.7569 6.57516 30.5555 6.60863 30.3595L8.2769 20.6336L1.2113 13.7472C1.06868 13.6083 0.967782 13.4323 0.920015 13.239C0.872248 13.0457 0.879519 12.8429 0.941007 12.6536C1.00249 12.4643 1.11574 12.2959 1.26794 12.1676C1.42014 12.0392 1.60522 11.9561 1.80223 11.9275L11.5665 10.5088L15.9334 1.66186C16.0217 1.48379 16.1579 1.33392 16.3268 1.22914Z"
					fill="#FFA310"
				/>
			</g>
			<defs>
				<clipPath id="clip0_739_1763">
					<rect
						width="32"
						height="32"
						fill="white"
						transform="translate(0.888855)"
					/>
				</clipPath>
				<clipPath id="clip1_739_1763">
					<rect
						width="32"
						height="32"
						fill="white"
						transform="translate(0.888855)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
